/**
 * NER-1283: pure theme helpers (auto / light / dark) — Customer App.
 *
 * Extraido aparte de ThemeContext para testear la logica sin React ni imports
 * que arrastren axios (mismo patron que admin-panel utils/theme.js — el repo no
 * tiene @testing-library).
 *
 * Preferencia ternaria persistida: 'light' | 'dark' | 'auto' (default 'auto').
 * El tema RESUELTO (lo que se pinta) siempre es 'light' | 'dark'.
 *
 * IMPORTANTE: el theme solo controla colores FUNDAMENTALES de UI generica
 * (bg/surface/text/border). El branding del restaurant (--color-primary, fonts,
 * radii) lo inyecta BrandingContext via inline style y SIEMPRE gana.
 */

// Clave logica nueva — el storage util la prefija como `carta_theme-preference`.
export const PREFERENCE_KEY = 'theme-preference';

// Clave legacy binaria (light|dark) que escribia la version anterior.
export const LEGACY_KEY = 'customer-theme';

// Orden del cycle del toggle: light -> dark -> auto -> light.
export const THEME_PREFERENCES = ['light', 'dark', 'auto'];

export const DEFAULT_PREFERENCE = 'auto';

export function isValidPreference(value) {
  return THEME_PREFERENCES.includes(value);
}

/**
 * Siguiente preferencia en el cycle light -> dark -> auto -> light.
 */
export function nextPreference(current) {
  const idx = THEME_PREFERENCES.indexOf(current);
  if (idx === -1) return DEFAULT_PREFERENCE;
  return THEME_PREFERENCES[(idx + 1) % THEME_PREFERENCES.length];
}

/**
 * Resuelve la preferencia a un tema concreto a aplicar.
 * Cuando es 'auto', usa el flag del sistema (prefers-color-scheme: dark).
 */
export function resolveTheme(preference, systemPrefersDark) {
  if (preference === 'dark') return 'dark';
  if (preference === 'light') return 'light';
  return systemPrefersDark ? 'dark' : 'light';
}

/**
 * Decide la preferencia inicial a partir de lo guardado.
 * - Si la clave nueva es valida, gana.
 * - Si no, migra desde la clave legacy binaria (light|dark).
 * - Si nada aplica, default 'auto'.
 * Retorna { preference, migratedFromLegacy } sin tocar el storage (puro).
 */
export function resolveInitialPreference(savedPreference, legacyValue) {
  if (isValidPreference(savedPreference)) {
    return { preference: savedPreference, migratedFromLegacy: false };
  }
  if (legacyValue === 'light' || legacyValue === 'dark') {
    return { preference: legacyValue, migratedFromLegacy: true };
  }
  return { preference: DEFAULT_PREFERENCE, migratedFromLegacy: false };
}
